import React from 'react';
import { useCopyToClipboard, formatters } from '../../../lib';
import { Button } from '../../Button';
import {
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from '../../Tooltip';

const ShareButton = ({
    onClick,
    href,
    icon,
}: {
    onClick?: React.MouseEventHandler<HTMLElement>;
    href?: string;
    icon: IconProp;
}) => (
    <Button
        shape="circle"
        size="large"
        target="_blank"
        onClick={onClick}
        href={href}>
        <FontAwesomeIcon size="sm" icon={icon} />
    </Button>
);

export type ShareButtonsProps = { url: string; text: string };

export const ShareButtons = ({ url, text }: ShareButtonsProps) => {
    const [status, onCopyClick] = useCopyToClipboard(url);
    const copyText = status === 'copied' ? 'Copiado' : 'Copiar';

    return (
        <>
            <Tooltip placement="top" title={copyText}>
                <div>
                    <ShareButton onClick={onCopyClick} icon={faLink} />
                </div>
            </Tooltip>
            <ShareButton
                href={formatters.buildWhatsappLink(url)}
                icon={faWhatsapp}
            />
            <ShareButton
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                icon={faLinkedinIn}
            />
            <ShareButton
                href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                icon={faFacebookF}
            />
            <ShareButton
                href={`https://twitter.com/intent/tweet?text=${text}&url=${url}`}
                icon={faTwitter}
            />
            <ShareButton
                href={`mailto:?subject=${text}&body=Artigo: ${url}`}
                icon={faEnvelope}
            />
        </>
    );
};
